var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadLogoProtools = function SvgFadLogoProtools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 128,
    cy: 128,
    r: 92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 80.77c27.094 0 36.41 18.143 43.998 31.187 10.798 18.56 11.931 31.154 35.889 40.868C210 140.22 210 141.57 210 127.5c0-45.563-36.937-82.5-82.5-82.5S45 81.937 45 127.5c0 11.61-1.603 13.593 2.549 25.325 20.955-6.887 30.758-29.192 34.67-39.144 5.526-14.056 18.187-32.91 45.281-32.91z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 105.385c17.128 0 25.34 27.176 34.333 39.68 10.89 15.14 18.7 19.677 33.53 30.455-14.83 21.907-39.915 36.305-68.363 36.305-28.686 0-53.953-14.64-68.735-36.858 17.722-4.457 30.55-22.243 34.306-29.902 3.756-7.658 17.801-39.68 34.929-39.68z",
    fill: "#FFF"
  }))));
};
export { SvgFadLogoProtools as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-logo-protools.fdcc35cb.svg";